import { useMemo } from 'react';

import BaseTimeSlots from 'reservations/availabilities/components/BaseTimeSlots';
import ViewAllAvailableTimeSlots from 'reservations/availabilities/components/ViewAllAvailableTimeSlots';
import type { Slot } from 'reservations/availabilities/types';

function getClosestAvailableTimes(
  slots: (Slot | null)[],
  slotIndex: number
): (Slot | null)[] {
  let left = slotIndex - 1;
  let right = slotIndex + 1;

  let leftMostAvailable = null;
  let rightMostAvailable = null;

  while (left >= 0) {
    if (slots[left]?.status === 1) {
      leftMostAvailable = left;
      break;
    }

    left--;
  }

  while (right < slots.length) {
    if (slots[right]?.status === 1) {
      rightMostAvailable = right;
      break;
    }

    right++;
  }

  return [leftMostAvailable, slotIndex, rightMostAvailable].map(index =>
    index === null ? null : slots[index]
  );
}

export type ClosestAvailableTimeSlotsProps = {
  slots: (Slot | null)[];
  time: number;
  name: string;
  // eslint-disable-next-line unused-imports/no-unused-vars
  handleSlotClick: (timeSlot: string) => void;
};

function ClosestAvailableTimeSlots({
  slots,
  handleSlotClick,
  name,
  time
}: ClosestAvailableTimeSlotsProps) {
  const closestAvailableTimeSlots = useMemo(
    () => getClosestAvailableTimes(slots, time),
    [time]
  );

  return (
    <>
      <BaseTimeSlots
        slots={closestAvailableTimeSlots}
        handleSlotClick={handleSlotClick}
        name={name}
      />
      <ViewAllAvailableTimeSlots
        time={time}
        slots={slots}
        name={name}
        handleSlotClick={handleSlotClick}
      />
    </>
  );
}

export default ClosestAvailableTimeSlots;
